<template>
    <div
        v-if="!message.isAutoGenerated"
        :id="`msg-id-${message.id}`"
        class="user-message message-body"
        :class="{ grouped: shouldHideMessageInfo }"
    >
        <div v-if="showEditMsgBox" class="edit-msg">
            <MessageInputHandler
                :initial-message="newMessage"
                :is-important="isImportant"
                :send="sendEditedMsg"
                :toggle-important="toggleImportant"
                :message="initialEditMsg"
                :closeEditMsg="closeEditMsgDialog"
                :refs-name="message.id"
            />
        </div>
        <div v-if="message.isDeprecated" class="user-message-body highlight-body">
            <span class="fst-italic">This message has been deleted.</span>
            <span class="undo-msg ps-1" v-if="showUndoButton" @click="undoDeletedMsg">Undo</span>
        </div>
        <template v-if="!showEditMsgBox && !message.isDeprecated">
            <div
                :class="`d-flex message-info w-100 ${
                    message.isImportant ? 'justify-content-between' : 'justify-content-end'
                }`"
                v-if="!shouldHideMessageInfo || message.isImportant || message.isEdited"
            >
                <span v-if="message.isImportant" class="text-danger fw-bold ms-3 me-1"> IMPORTANT </span>
                <span>
                    <span v-if="message.isEdited" class="mx-1"> Edited </span>
                    <span v-if="!shouldHideMessageInfo" class="text-end">{{
                        formatMessageTime(message.createdOn)
                    }}</span>
                </span>
            </div>
            <div class="d-flex align-items-center justify-content-end w-100">
                <!-- Sending -->
                <div v-if="message.isLoading" class="text-danger me-2">
                    <img src="../../../../../assets/images/chat/message-pending-timer.png" />
                </div>
                <div v-if="message.isImportant" class="text-danger me-2">
                    <i class="fas fa-exclamation"></i>
                </div>
                <!-- Content -->
                <MessageHoverActions
                    ref="hoverActions"
                    position="left"
                    :message-id="message.id"
                    @hover-closed="closeEmojiPicker"
                >
                    <template #message>
                        <div :class="`user-message-body highlight-body ${message.isError ? 'message-error' : ''}`">
                            <!-- Reply of Message -->
                            <div
                                class="card bg-form-section material-card reply-message-body my-1 cursor-pointer"
                                v-if="message.replyToMessage"
                                @click="handleReplyMsgNavigation"
                            >
                                <div class="d-flex w-100">
                                    <span class="message-info reply-message-info">
                                        <span class="me-2">
                                            {{ message.replyToMessage.senderDetails.firstName }}
                                            {{
                                                message.replyToMessage.senderDetails?.lastName
                                                    ? message.replyToMessage.senderDetails?.lastName
                                                    : ""
                                            }}
                                        </span>
                                        <span class="me-2">
                                            {{ formatMessageTime(message.replyToMessage.createdOn) }}</span
                                        >
                                    </span>
                                </div>
                                <template v-if="message.replyToMessage.text">
                                    <span
                                        class="reply-message-text my-1"
                                        v-html="
                                            sanitizeMarkup(markdownToHtml(formatReplyToMsgText(message.replyToMessage)))
                                        "
                                    ></span>
                                </template>
                                <span v-else-if="replyMsgProfiles">
                                    <span
                                        v-for="profile in replyMsgProfiles"
                                        :key="profile.id"
                                        class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                                    >
                                        <i class="fas fa-user-circle fa-lg pe-1"> </i>
                                        <span> {{ profile.name }} </span>
                                    </span>
                                </span>
                            </div>
                            <!-- Reply of Message Ends-->
                            <div v-if="isLastMessage && hasTestAgency">
                                <div class="message-status">
                                    <!-- GROUP CONVERSATION -->
                                    <template v-if="isGroupConversation">
                                        <img
                                            v-if="
                                                (activeConversation.loginIds?.length || 0) > 0 &&
                                                (message.readList?.length || 0) ===
                                                    (activeConversation.loginIds?.length || 0)
                                            "
                                            src="../../../../../assets/images/chat/open-eye.svg"
                                            class="status-icon seen-icon"
                                            title="Seen by everyone"
                                            alt="Seen by everyone"
                                        />

                                        <img
                                            v-else
                                            src="../../../../../assets/images/chat/bicheck-circle.svg"
                                            class="status-icon sent-icon"
                                            title="Sent"
                                            alt="Sent"
                                        />

                                        <!-- Read Count -->
                                        <div v-if="showReadCount" class="read-by-summary">
                                            <!-- ADD TWO ICONS  -->
                                            <img
                                                v-if="
                                                    (activeConversation.loginIds?.length || 0) > 0 &&
                                                    (message.readList?.length || 0) ===
                                                        (activeConversation.loginIds?.length || 0)
                                                "
                                                src="../../../../../assets/images/chat/open-eye.svg"
                                                class="status-icon seen-icon"
                                                title="Seen by everyone"
                                                alt="Seen by everyone"
                                            />

                                            <img
                                                v-else
                                                src="../../../../../assets/images/chat/close-eye.svg"
                                                class="status-icon sent-icon"
                                                title="Not seen by everyone"
                                                alt="Not seen by everyone"
                                            />

                                            <!--  - ONLY this opens Read Users -->
                                            <span class="read-count">
                                                <Span>Read By </Span>
                                                {{
                                                    (message.readList?.length || 0) +
                                                    "/" +
                                                    (activeConversation.loginIds?.length || 0)
                                                }}
                                                <span
                                                    v-if="(message.readList?.length || 0) > 0"
                                                    class="read-users-arrow"
                                                    @click.stop="toggleReadUsers"
                                                >
                                                    <img
                                                        src="../../../../../assets/images/openicon.svg"
                                                        class="read-arrow-icon"
                                                        alt="View read users"
                                                    />
                                                </span>
                                            </span>
                                        </div>

                                        <!-- Read Users -->
                                        <div v-if="showReadUsers && message.readList?.length" class="read-by-users">
                                            <div
                                                v-for="(user, index) in message.readList || []"
                                                :key="index"
                                                class="read-user"
                                                v-html="user"
                                            ></div>
                                        </div>
                                    </template>

                                    <!-- ONE TO ONE CONVERSATION -->
                                    <template v-else>
                                        <img
                                            v-if="message.readList?.length > 0"
                                            src="../../../../../assets/images/chat/open-eye.svg"
                                            class="status-icon seen-icon"
                                            title="Seen"
                                            alt="Seen"
                                        />

                                        <img
                                            v-else
                                            src="../../../../../assets/images/chat/bicheck-circle.svg"
                                            class="status-icon sent-icon"
                                            title="Sent"
                                            alt="Sent"
                                        />
                                    </template>
                                </div>
                            </div>

                            <div class="message-content" v-html="sanitizeMarkup(markdownToHtml(formatMsgText()))"></div>
                            <!-- Shared Profiles -->

                            <template v-if="sharedProfilesList?.length > 0">
                                <p class="profile-box">
                                    <span
                                        v-for="profile in sharedProfilesList"
                                        :key="profile.id"
                                        class="cursor-pointer"
                                    >
                                        <span
                                            contenteditable="false"
                                            class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                                        >
                                            <i class="fas fa-user-circle fa-lg pe-1"> </i>
                                            <span @click="(e) => getProfileRedirectURL(profile, e)">
                                                {{ profile.name }}
                                            </span>
                                        </span>
                                    </span>
                                </p>
                            </template>
                            <!-- Files -->
                            <template v-if="message.assetIds.length > 0">
                                <div class="loader-parent" v-if="assetLoading">
                                    <div class="msg-loader"></div>
                                </div>
                                <ul v-if="fetchedAssets.length > 0 && !assetLoading" class="d-flex flex-wrap gap-1">
                                    <template v-for="(assetResponse, index) in fetchedAssets" :key="index">
                                        <template v-if="isImage(assetResponse.asset.mimeType)">
                                            <div class="position-relative">
                                                <img
                                                    :class="`image my-2 ${
                                                        assetResponse.asset.showDownloadBtn ? 'image-blur' : ''
                                                    }`"
                                                    :src="assetResponse.asset.url"
                                                    :alt="assetResponse.asset.fileName"
                                                    @click="
                                                        (e) =>
                                                            showImageOverlay(
                                                                index,
                                                                !assetResponse.asset.showDownloadBtn,
                                                                e
                                                            )
                                                    "
                                                />
                                                <a
                                                    href="javascript:void(0);"
                                                    v-if="assetResponse.asset.showDownloadBtn"
                                                    class="img-download-btn"
                                                    @click="(e) => downloadAsset(assetResponse.asset, e)"
                                                >
                                                    <i class="fas fa-download me-1"></i>
                                                    <span class="file-size">{{
                                                        formatFileSize(assetResponse.asset.fileSize)
                                                    }}</span>
                                                </a>
                                            </div>
                                        </template>
                                        <span v-else>
                                            <div
                                                class="m-1 py-2 px-2 file-render text-light d-flex flex-column justify-content-end position-relative"
                                            >
                                                <a
                                                    class="file-download"
                                                    :href="assetResponse.asset.url"
                                                    @click="(e) => downloadAsset(assetResponse.asset, e)"
                                                    ><i class="fas fa-download me-1"></i>
                                                    <span class="file-size">{{
                                                        formatFileSize(assetResponse.asset.fileSize)
                                                    }}</span></a
                                                >
                                                <p class="fw-bold mb-0">
                                                    {{ truncateString(assetResponse.asset.fileName.split(".")[0], 45) }}
                                                </p>
                                                <p class="mb-0 file-details">
                                                    <span class="pe-1">{{
                                                        assetResponse.asset.fileName.split(".").pop().toUpperCase()
                                                    }}</span>
                                                    <span class="file-size">{{
                                                        formatFileSize(assetResponse.asset.fileSize)
                                                    }}</span>
                                                </p>
                                            </div>
                                        </span>
                                    </template>
                                </ul>
                            </template>
                        </div>
                    </template>
                    <!-- SLOT: hover actions -->
                    <template #actions>
                        <div v-if="!showReadCount" class="hover-actions-card">
                            <div class="hover-reactions">
                                <!-- Emoji quick reactions -->
                                <span
                                    v-for="emoji in defaultQuickReactions"
                                    :key="emoji"
                                    class="reactions-btn"
                                    @click="handleEmoji(emoji)"
                                >
                                    {{ emoji }}
                                </span>
                                <!-- Emoji picker -->
                                <div @click.stop>
                                    <EmojiPicker :isHover="true" ref="emojiPicker" @emoji-selected="handleEmoji" />
                                </div>

                                <!-- Divider -->
                                <div class="hover-divider"></div>

                                <!-- Edit -->
                                <span
                                    class="hover-action-btn"
                                    @click="editMessage"
                                    v-tooltip="{ title: `Edit`, placement: 'top' }"
                                >
                                    <img src="../../../../../assets/images/chat/edit-pencil.svg" />
                                </span>

                                <!-- Reply -->
                                <span
                                    class="hover-action-btn"
                                    @click="replyToMessage"
                                    v-tooltip="{ title: `Reply`, placement: 'top' }"
                                >
                                    <img src="../../../../../assets/images/chat/reply.svg" />
                                </span>
                                <span
                                    class="hover-action-btn delete-btn"
                                    @click.stop="deleteMessage"
                                    v-tooltip="{ title: 'Delete', placement: 'top' }"
                                >
                                    <img src="../../../../../assets/images/chat/delete.svg" class="status-icon" />
                                </span>
                                <!-- More -->
                                <span
                                    v-if="isGroupConversation && isLastMessage && hasTestAgency"
                                    class="hover-action-btn"
                                    @click.stop="toggleReadCount"
                                    v-tooltip="{ placement: 'top' }"
                                >
                                    <i class="fas fa-ellipsis-h font-size-lg"></i>
                                </span>
                            </div>
                        </div>
                    </template>
                </MessageHoverActions>
            </div>
            <MessageReactions :message="message" />
        </template>
        <div class="mt-1" v-if="!message.isLoading && message.isError">
            <button type="button" class="btn btn-xs py-0 retry-btn" @click="retryMessage(message)">
                Not Delivered
                <img class="retry-icon" src="../../../../../assets/images/chat/refresh.png" />
            </button>
        </div>
    </div>
</template>

<script lang="ts" src="./UserMessage.ts"></script>
<style src="./UserMessage.scss"></style>
